"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlexCell = exports.Flexbox = exports.FlexDirectionType = void 0;
var tslib_1 = require("tslib");
var React = (0, tslib_1.__importStar)(require("react"));
var FlexDirectionType;
(function (FlexDirectionType) {
    FlexDirectionType["COLUMN"] = "column";
    FlexDirectionType["ROW"] = "row";
    FlexDirectionType["COLUMN_REVERSE"] = "column-reverse";
    FlexDirectionType["ROW_REVERSE"] = "row-reverse";
})(FlexDirectionType = exports.FlexDirectionType || (exports.FlexDirectionType = {}));
function Flexbox(props) {
    var style = (0, tslib_1.__assign)({ alignContent: props.alignContent, alignItems: props.alignItems, alignSelf: props.alignSelf, display: props.display || 'flex', flexBasis: props.flexBasis, flexDirection: props.flexDirection, flexGrow: props.flexGrow ? Number(props.flexGrow) : 'initial', flexShrink: props.flexShrink ? Number(props.flexShrink) : 'initial', flexWrap: props.flexWrap, flex: props.flex, gap: props.gap, height: props.height, justifyContent: props.justifyContent, margin: props.margin, marginBottom: props.marginBottom, marginLeft: props.marginLeft, marginRight: props.marginRight, marginTop: props.marginTop, maxHeight: props.maxHeight, maxWidth: props.maxWidth, minHeight: props.minHeight, minWidth: props.minWidth, order: props.order, padding: props.padding, paddingBottom: props.paddingBottom, paddingLeft: props.paddingLeft, paddingRight: props.paddingRight, paddingTop: props.paddingTop, width: props.width }, props.style);
    Object.keys(style).forEach(function (key) { return style[key] === undefined && delete style[key]; });
    return (React.createElement("div", { style: style, "data-testid": props.testId }, props.children));
}
exports.Flexbox = Flexbox;
function FlexCell(props) {
    var style = {
        flex: props.flex,
        alignSelf: props.alignSelf,
        height: props.height,
        width: props.width,
        minWidth: props.minWidth,
    };
    return React.createElement("div", { style: style }, props.children);
}
exports.FlexCell = FlexCell;
//# sourceMappingURL=index.js.map